export default ({ initialValues = {} }) => {
  return initialValues;
};
